export const SUBMIT_SUBSTANCE_TR_FORM = 'substanceTRForm/SUBMIT_SUBSTANCE_TR_FORM';
